import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';
import {CommonActions} from '@react-navigation/routers';
import moment from 'moment';

import withScreenIsFocused from '../components/hoc/with-screen-is-focused';
import ChevronLeftIcon from '../images/md-icons/chevron_left/materialicons/24px.svg';
import {Intro} from '../screens/confirm';
import Overview from '../screens/shared/overview';
import {Pay, Complete, Thanks} from '../screens/shared/checkout';
import Chat from '../screens/shared/chat';
import Error from '../screens/shared/error';

const ConfirmStack = createStackNavigator();

const renderCompleteDescription = ({order}) => {
  if (!order || !order.datetime) {
    return null;
  }

  if (order.pickup_address) {
    return `We komen je auto halen op ${moment(order.datetime).format(
      'dddd D MMMM YYYY',
    )} om ${moment(order.datetime).utc().format('H:mm')}. Tot dan.`;
  }

  return `We zien je graag op ${moment(order.datetime).format(
    'dddd D MMMM YYYY',
  )} vanaf ${moment(order.datetime).utc().format('H:mm')}.`;
};

export default () => (
  <ConfirmStack.Navigator
    initialRouteName="Index"
    screenOptions={{
      headerBackImage: () => <ChevronLeftIcon />,
      headerTitle: '',
      headerStyle: {
        shadowColor: 'transparent',
        borderBottomWidth: 0,
        elevation: 0,
      },
      cardStyle: {flex: 1},
    }}>
    <ConfirmStack.Screen name="Index" component={withScreenIsFocused(Intro)} />
    <ConfirmStack.Screen
      name="Details"
      component={withScreenIsFocused(Overview)}
    />
    <ConfirmStack.Screen name="Chat" component={withScreenIsFocused(Chat)} />
    <ConfirmStack.Screen name="Pay" component={withScreenIsFocused(Pay)} />
    <ConfirmStack.Screen
      name="Complete"
      component={withScreenIsFocused((props) => (
        <Complete
          {...props}
          description={renderCompleteDescription}
          onComplete={() => {
            props.navigation.dispatch(
              CommonActions.reset({
                index: 1,
                routes: [
                  {
                    name: 'Overview',
                    params: {
                      screen: 'Index',
                      params: {order_id: props.route.params?.order_id},
                    },
                  },
                  {
                    name: 'Overview',
                    params: {
                      screen: 'Chat',
                      params: {order_id: props.route.params?.order_id},
                    },
                  },
                ],
              }),
            );
          }}
        />
      ))}
    />
    <ConfirmStack.Screen
      name="Thanks"
      component={withScreenIsFocused((props) => (
        <Thanks
          {...props}
          title="Bedankt voor je beoordeling!"
          description={renderCompleteDescription}
        />
      ))}
    />
    <ConfirmStack.Screen name="Error" component={withScreenIsFocused(Error)} />
  </ConfirmStack.Navigator>
);
